import { Group, Link, Text } from '@ekhodealer/ekho-common/rev';

interface SelectAllBannerProps {
	/** Number of items selected (page count or individual count) */
	selectedCount: number;
	/** Total items matching current filters across all pages */
	totalCount: number;
	/** Whether the header checkbox "select all" is active (React Aria 'all') */
	isAllPageSelected: boolean;
	/** Whether user explicitly chose "select all matching results" */
	isAllMatchingSelected: boolean;
	/** Callback when user clicks "Select all X" */
	onSelectAllMatching: () => void;
	/** Callback when user clicks "Clear selection" */
	onClearSelection: () => void;
	/** Resource name for display (e.g., 'discounts', 'leads', 'orders') */
	resourceName: string;
}

export function SelectAllBanner({
	selectedCount,
	totalCount,
	isAllPageSelected,
	isAllMatchingSelected,
	onSelectAllMatching,
	onClearSelection,
	resourceName,
}: SelectAllBannerProps): React.ReactNode {
	if (isAllMatchingSelected) {
		return (
			<Group noWrap itemsSpacing='8' itemsAlignY='center'>
				<Text size='bodySmall' weight='semibold'>
					All {totalCount} selected
				</Text>
				<Text size='bodySmall'>·</Text>
				<Link onPress={onClearSelection}>
					<Text size='bodySmall' weight='semibold'>
						Clear selection
					</Text>
				</Link>
			</Group>
		);
	}

	if (isAllPageSelected && totalCount > selectedCount) {
		return (
			<Group noWrap itemsSpacing='8' itemsAlignY='center'>
				<Text size='bodySmall' weight='semibold'>
					{selectedCount} selected
				</Text>
				<Text size='bodySmall'>·</Text>
				<Link onPress={onSelectAllMatching}>
					<Text size='bodySmall' weight='semibold'>
						Select all {totalCount} {resourceName}
					</Text>
				</Link>
			</Group>
		);
	}

	return (
		<Text size='bodySmall' weight='semibold'>
			{selectedCount} selected
		</Text>
	);
}
